var React = require('react');

function DeveloperConsoleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 19V7H4V19H20ZM20 3C20.5304 3 21.0391 3.21071 21.4142 3.58579C21.7893 3.96086 22 4.46957 22 5V19C22 19.5304 21.7893 20.0391 21.4142 20.4142C21.0391 20.7893 20.5304 21 20 21H4C3.46957 21 2.96086 20.7893 2.58579 20.4142C2.21071 20.0391 2 19.5304 2 19V5C2 3.89 2.9 3 4 3H20ZM13 17V15H18V17H13ZM9.58 13L5.57 9H8.4L11.7 12.3C12.09 12.69 12.09 13.33 11.7 13.72L8.42 17H5.59L9.58 13Z"}));
}

DeveloperConsoleInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"black"};

module.exports = DeveloperConsoleInline;

DeveloperConsoleInline.default = DeveloperConsoleInline;
